var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select_custom"},[_c('v-select',{class:['filter', this.className],attrs:{"options":this.options,"keys":this.keys,"clearable":this.config.clearable,"searchable":this.config.searchable,"placeholder":this.placeholder,"components":{OpenIndicator: _vm.OpenIndicator}},on:{"input":this.onSelectChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }